module.exports = __webpack_public_path__ + "img/discount-panel.4e22075f.webp";